<template>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <p class="title text-xs-center">Add New Advertiser</p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="Advertiser Name"
            required
          ></v-text-field>
          
          <v-autocomplete
            :items="countries"
            v-model="country"
            :rules="[v => !!v || 'Please select country name.']"
            label="Select Country"
            persistent-hint
            required
          ></v-autocomplete>
    
          <v-checkbox
            v-model="status"
            :rules="[v => !!v || 'Please check the box to make advertiser active.']"
            label="Do you want to make it active?"
            required
          ></v-checkbox>
          <div class="text-xs-center">
          <v-btn @click="clear">clear</v-btn>

          <v-btn
            color="primary"
            :disabled="!valid"
            @click="submit"
          >
            submit
          </v-btn>
          </div>
        </v-form>
      </v-flex>
    </v-layout>
</template>

<script>
  import axios from 'axios'

  import { SERVER_URL } from './../../constant.js'

  export default {
    data: () => ({
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required'
      ],
      country: '',
      status: false,
      countries: []
    }),
    created () {
      document.title = 'Add Advertiser';
      axios.get(`${SERVER_URL}/country/all`).then(res => {
        res.data.forEach(val => {
          this.countries.push(val.name)
        })
      })
    },
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          axios.post(`${SERVER_URL}/advertiser/add`, {
            name: this.name,
            country: this.country,
            status: this.status
          }).then(res => {
            var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Advertiser Added Successfully'})
            document.dispatchEvent(showSnackbarEvent)
            this.$refs.form.reset()
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/advertiser/AddAdvertiser.vue